<template>
  <div id="main">
    <div v-if="!exception" class="ui top fixed fluid item inverted menu" :class="numOfBarItems">
      <router-link :to="{ path: '/video/event' }" class="item" active-class="active" :class="{ hidden: eventId == undefined }">
        {{$t('Trends')}}
      </router-link>
      <router-link :to="'/video/eznode_hot'" class="item" active-class="active">
        {{$t('Hot')}}
      </router-link>
      <router-link :to="'/video/youtube'" class="item" active-class="active">
        {{$t('Popular')}}
      </router-link>
      <router-link :to="{ path: '/video/youtube_live' }" class="item" active-class="active">
        {{$t('Live')}}
      </router-link>
      <router-link :to="{ path: '/video/recommendation' }" class="item" active-class="active" :class="{ hidden: !hasRecommendations }">
        {{$t('For You')}}
      </router-link>
      <router-link :to="{ name: 'settings' }" class="item" active-class="active"><i class="cogs icon"></i></router-link>
    </div>
    <div class="ui container">      
      <ErrorMessage v-if="exception" :message="$t(errorMessage, {keySeparator:'#'})" :exception="exception">
      </ErrorMessage>
      <div v-else>
        <router-view></router-view>
      </div>
    </div>    
  </div>
</template>

<script>
import ErrorMessage from './components/ErrorMessage';
import { mapState, mapActions } from 'vuex'

const gtag = window.gtag;

export default {
  name: 'app',
  data () {
    return {
    };
  },
  computed: {
    errorMessage () {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get('msg') || this.$t('Something wrong or session has expired.', { keySeparator:'#' });
    },
    numOfBarItems() {
      let numOfBarItems = 4;
      if (this.hasRecommendations) {
        numOfBarItems++;
      }
      if (this.eventId != undefined) {
        numOfBarItems++;
      }
      return ['', 'one', 'two', 'three', 'four', 'five'][numOfBarItems];
    },
    hasRecommendations() {
      const urlParams = new URLSearchParams(window.location.search);
      const videoSource = urlParams.get('source');
      if (videoSource == undefined || videoSource == '' || videoSource == 'recommendation') {
        return true;
      }
      return false;
    },
    ...mapState([
      'videos',
      'exception',
      'videoSource',
      'eventId',
      'isLoggedInUser',
    ]),
  },
  mounted () {
    if (this.exception) { // skip following operations when exception occurs when initialization
      return;
    }
    (async () => {
      await this.resetUnreadCount();
    })()
    .catch((err) => {
      gtag('event', 'exception', {
        description: `exception occurs when mounted. ${err.toString && err.toString()}`,
        fatal: true,
      });
    });
  },
  methods: {
    ...mapActions([
      'fetchVideos',
      'resetUnreadCount',
    ]),
  },
  components: {
    ErrorMessage,
  },
}
</script>

<style>
body {
  background-color: black;
  background-image: radial-gradient(760px at top center,
    rgba(225, 123, 148, 0.65), rgba(225, 123, 148, 0)
  );
}
.hidden {
  display: none !important;
}
.ui.fixed.menu {
  background-color: rgb(133, 67, 84);
  box-shadow: 3px 3px 3px 1px rgba(0, 0, 0, 0.2);
}
.ui.grid {
  margin-top: 0px;
}
.ui.card {
  width: 100%;
  height: 100%;
  margin: 0px;
  box-shadow: 3px 3px 3px 1px rgba(0, 0, 0, 0.2);
}
#main {
  padding-top: 3.5rem;
  height: 100%;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}
.ui.info.message {
  background: none;
  color: #ffffff;
  font-family: Helvetica, Arial, sans-serif;
  font-weight: 200;
  border-radius: 59px;
  border: 2px solid transparent;
  background: #000;
  background-clip: padding-box;
  box-shadow: none;
  padding: 1em;
  text-align: center;
  margin-bottom: 0;
}

.ui.toggle.checkbox label {
  color: white;
}
.ui.toggle.checkbox input:checked~label {
  color: white !important;
}
.ui.toggle.checkbox input:checked~label:before {
  background-color: rgb(160, 104, 119) !important;
}
.ui.segment {
  background-color: transparent;
}
</style>
